module.exports = "https://static.wmbcdn.com/uniweb/images/3d6e6454043549247c6cb6531452f9f9.svg";